"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[596],{

/***/ 61740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ product_sign_up; }
});

// UNUSED EXPORTS: productIdToCluster

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
// EXTERNAL MODULE: ./services/clusters-service.js + 1 modules
var clusters_service = __webpack_require__(25866);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/default-props.js
/* harmony default export */ var default_props = ({});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.scss.js

var StyledProductSignUp = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ef6wzw60"
})("display:flex;flex-direction:row;height:50px;.product-logo-image{display:flex;align-items:center;.picture-component{img{width:160px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}











var _obj;
var PRODUCT_TYPE_TO_IMAGE = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162032.png"), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162033.png"), (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162031.png"), _obj);
var _obj1;
var productIdToCluster = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, products/* CRM_PRODUCT_ID */.$, clusters.CRM), (0,_define_property/* default */.Z)(_obj1, products/* DEV_PRODUCT_ID */.xi, clusters.SOFTWARE), _obj1);
var ProductSignUp = function(_param) {
    var displayImage = _param.displayImage, useCtaText = _param.useCtaText, buttonSize = _param.buttonSize, withButtonArrow = _param.withButtonArrow, ctaText = _param.ctaText, _productType = _param.productType, productType = _productType === void 0 ? products/* WORK_MANAGEMENT_PRODUCT_ID */.py : _productType, _selectedProductIds = _param.selectedProductIds, selectedProductIds = _selectedProductIds === void 0 ? [] : _selectedProductIds, signupClusterId = _param.signupClusterId, useCtaIcon = _param.useCtaIcon, _buttonColor = _param.buttonColor, buttonColor = _buttonColor === void 0 ? color_consts.WHITE_COLOR_NAME : _buttonColor, invert = _param.invert, beforeSubmitCallback = _param.beforeSubmitCallback, excludeFromWMHighIntentExperienceTest = _param.excludeFromWMHighIntentExperienceTest, restOfConfig = _object_without_properties(_param, [
        "displayImage",
        "useCtaText",
        "buttonSize",
        "withButtonArrow",
        "ctaText",
        "productType",
        "selectedProductIds",
        "signupClusterId",
        "useCtaIcon",
        "buttonColor",
        "invert",
        "beforeSubmitCallback",
        "excludeFromWMHighIntentExperienceTest"
    ]);
    var updateClusters = function() {
        var res = [];
        if (selectedProductIds.length < 3) {
            selectedProductIds.forEach(function(id) {
                var clusterId = productIdToCluster[id];
                if (clusterId) res.push({
                    clusterId: clusterId,
                    clusterType: types.CLUSTER_TYPE
                });
            });
            (0,clusters_service/* updateUserClustersListWithMultipleClusters */.aC)(res, clusters.HP_TAGS_SELECTION);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductSignUp, {
        className: "product-sign-up",
        children: [
            displayImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-logo-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: PRODUCT_TYPE_TO_IMAGE[productType]
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, _object_spread_props(_object_spread({}, restOfConfig), {
                withButtonArrow: withButtonArrow,
                useCtaIcon: useCtaIcon,
                productIdToUse: productType,
                signupClusterId: signupClusterId,
                useCtaText: useCtaText,
                ctaText: ctaText,
                buttonSize: buttonSize !== null && buttonSize !== void 0 ? buttonSize : sizes.SM,
                buttonColor: buttonColor,
                invert: invert,
                beforeSubmitCallback: function() {
                    updateClusters();
                    beforeSubmitCallback && beforeSubmitCallback();
                },
                skipUpdateCluster: true,
                signupProductId: productType,
                extraData: {
                    selectedProduct: productType
                },
                excludeFromWMHighIntentExperienceTest: excludeFromWMHighIntentExperienceTest
            }))
        ]
    });
};
/* harmony default export */ var product_sign_up = (ProductSignUp);
ProductSignUp.defaultProps = default_props;


/***/ }),

/***/ 40596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ side_by_side_paragraph_and_tags_homepage_first_fold_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/side-by-side-paragraph-and-tags-homepage-first-fold-component.scss.js


var StyledSideBySideParagraphAndTagsHomepageFirstFoldComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1uc30j60"
})("margin-left:calc(max((100vw - ", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px) / 2 + 32px,32px));display:flex;gap:", function(param) {
    var gap = param.gap;
    return gap;
}, ";min-height:", function(param) {
    var minHeight = param.minHeight;
    return minHeight;
}, ";.full-paragraph{margin-top:", function(param) {
    var fullParagraphTopMargin = param.fullParagraphTopMargin;
    return fullParagraphTopMargin;
}, ";width:fit-content;justify-content:center;}.tags-and-assets-component{flex:1;}.clickable-tags-grid{gap:calc(min(20 * (100vw / 1920),20px));padding:calc(min(24 * (100vw / 1920),24px));border-radius:calc(min(18 * (100vw / 1920),18px));.animated-text-component,.extra-details .title{font-size:calc(max(min(16 * (100vw / 1920),1rem),0.8125rem));}.tags-container{grid-gap:calc(min(12 * (100vw / 1920),12px));.tag-component{font-size:calc(max(min(14 * (100vw / 1920),0.875rem),0.75rem));width:calc(max(min(100 * (100vw / 1920),100px),80px));height:calc(max(min(96 * (100vw / 1920),96px),76px));.checkbox{top:calc(max(min(10 * (100vw / 1920),10px),7.5px));left:calc(max(min(10 * (100vw / 1920),10px),7.5px));width:calc(max(min(16 * (100vw / 1920),16px),12px));height:calc(max(min(16 * (100vw / 1920),16px),12px));border-radius:calc(max(min(4 * (100vw / 1920),4px),2.5px));.checkmark svg{width:calc(max(min(9 * (100vw / 1920),9px),7px));height:calc(max((min(8 * (100vw / 1920),8px)),6px;));}}.icon{svg{height:calc(max(min(20 * (100vw / 1920),20px),16px));width:calc(max(min(20 * (100vw / 1920),20px),16px));}}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/tags-and-assets/tags-and-assets-component.scss.js


var StyledTagsAndAssetsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "es1qpe70"
})("position:relative;.use-cases-container{display:flex;flex-direction:column;gap:8px;z-index:", z_index/* LAYER_TWO */.wc, ";position:absolute;top:calc(132 * (100vw / 1920));left:0;.extra-details-component{opacity:0;}&.breathe{animation:breathe 0.3s linear;}&.with-extra-details{.extra-details-component{opacity:1;transition:opacity 0.3s ease-in-out;}}}img{width:100%;object-fit:contain;max-width:900px;}.default-asset{opacity:0;transition:opacity 0.3s ease-in-out;&.active{display:block;z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";opacity:1;}}.assets-container{z-index:", z_index/* LAYER_ONE */.KW, ";position:relative;margin-left:10vw;.picture-wrapper{position:absolute;opacity:0;top:0;left:0;transition:opacity 0.3s ease-in-out;&.selected{opacity:1;}}}@keyframes breathe{0%{transform:scale(1);}50%{transform:scale(1.05);}100%{transform:scale(1);}}");

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/clickable-tags-grid.scss.js



var StyledClickableTagsGrid = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1e3293k0"
})("display:flex;flex-direction:column;width:fit-content;padding:24px 16px 16px;gap:20px;background:linear-gradient(180deg,rgba(255,255,255,0.8) 40%,rgba(240,243,255,0.3) 80%);box-shadow:3.977px 3.977px 34.8px 0 rgba(0,0,0,0.15);border-radius:18px;border:1px solid ", colors/* default */.Z[color_consts.GAINSBORO_COLOR_NAME], ";backdrop-filter:blur(24px);.tags-container{width:fit-content;display:grid;grid-template-rows:1fr 1fr 1fr;grid-template-columns:1fr 1fr 1fr;grid-gap:12px;}.extra-details{display:flex;flex-direction:column;gap:8px;.title{line-height:24px;font-weight:400;font-size:1rem;}.picture-component img{height:28px;object-fit:contain;object-position:left;}}");

// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/tag/tag-component.scss.js



var TAG_WIDTH = 100;
var TAG_HEIGHT = 96;
var StyledTagComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1n0wom20"
})("display:flex;position:relative;align-items:center;gap:8px;flex-direction:column;flex-wrap:wrap;justify-content:center;border-radius:8px;background-color:", colors/* default.White */.Z.White, ";border:0.6px solid ", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR], ";width:", TAG_WIDTH, "px;height:", TAG_HEIGHT, "px;cursor:pointer;font-size:0.875rem;&:hover{box-shadow:0 0 20px 0 rgba(0,0,0,0.08);}&.tag-animation{animation:breatheOut 0.3s linear;}.checkbox{position:absolute;top:10px;left:10px;}@keyframes breatheOut{0%{transform:scale(1);}15%{transform:scale(1.01);}20%{transform:scale(1.02);}25%{transform:scale(1.03);}32%{transform:scale(1.04);}50%{transform:scale(1.05);}68%{transform:scale(1.04);}75%{transform:scale(1.03);}80%{transform:scale(1.02);}85%{transform:scale(1.01);}100%{transform:scale(1);}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/checkbox/checkbox.scss.js



var StyledCheckbox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1wtfxrn0"
})("cursor:pointer;position:relative;border-radius:4px;background-color:", colors/* default.White */.Z.White, ";border:1.25px solid ", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR], ";width:16px;height:16px;display:flex;align-items:center;justify-content:center;.checkmark{opacity:0;display:flex;transition:opacity 0.2s ease-in-out;}", function(param) {
    var hovered = param.hovered, color = param.color;
    return hovered && "border-color: ".concat(color);
}, ";&.checked{border-color:", function(param) {
    var color = param.color;
    return color;
}, ";.checkmark{opacity:1;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/checkbox/check-icon.js

var CheckIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "9",
        height: "8",
        viewBox: "0 0 9 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 3.5L3.5 6.5L7.5 1",
            stroke: color || "#6161FF",
            "stroke-width": "1.25",
            strokeLinecap: "round"
        })
    });
};

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/checkbox/checkbox.js





var Checkbox = function(param) {
    var checked = param.checked, color = param.color, hovered = param.hovered;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheckbox, {
        hovered: hovered,
        color: color,
        className: classnames_default()("checkbox", {
            checked: checked
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "checkmark",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {
                color: color
            })
        })
    });
};
/* harmony default export */ var checkbox_checkbox = (Checkbox);

// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/tag/tag-component.js








var TagComponent = function(param) {
    var onClick = param.onClick, Icon = param.Icon, text = param.text, tagColor = param.tagColor, selected = param.selected;
    var ref = (0,react.useState)(false), isHover = ref[0], setIsHover = ref[1];
    var ref1 = (0,react.useState)(false), tagAnimation = ref1[0], setTagAnimation = ref1[1];
    var onTagClick = function() {
        setTagAnimation(true);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.GRID_TAG_CLICKED, {
            kind: text
        });
        onClick && onClick();
    };
    var onMouseEnter = function() {
        setIsHover(true);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.GRID_TAG_HOVERED, {
            kind: text
        });
    };
    var onMouseLeave = function() {
        setIsHover(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTagComponent, {
        color: colors/* default */.Z[tagColor],
        className: classnames_default()("tag-component", {
            selected: selected,
            "tag-animation": tagAnimation
        }),
        onMouseLeave: onMouseLeave,
        onMouseEnter: onMouseEnter,
        onClick: onTagClick,
        onAnimationEnd: function() {
            return setTagAnimation(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox, {
                color: colors/* default */.Z[tagColor],
                checked: selected,
                hovered: isHover
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "icon",
                children: Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    color: (selected || isHover) && colors/* default */.Z[tagColor]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text",
                children: text
            })
        ]
    });
};
/* harmony default export */ var tag_component = (TagComponent);

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/animated-text/animated-text-component.scss.js



var ANIMATION_DELAY = 0.05;
var ANIMATION_DURATION = 0.5;
var getAnimationStyle = function(wordIndex) {
    return "\n  .animated-word:nth-child(".concat(wordIndex + 1, ") {\n    animation-delay: ").concat(wordIndex * ANIMATION_DELAY, "s;\n  }\n");
};
var getWordAnimationsStyle = function(words) {
    return words.map(function(word, index) {
        return getAnimationStyle(index);
    }).join("\n");
};
var StyledAnimatedTextComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e3zr0hf0"
})("display:flex;font-size:1rem;line-height:24px;position:relative;.animated-word{position:relative;display:inline-block;font-weight:400;animation:textAnimation ", ANIMATION_DURATION, "s ease-in-out forwards;}", function(param) {
    var words = param.words;
    return getWordAnimationsStyle(words);
}, ";@keyframes textAnimation{0%,100%{color:black;}50%{color:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/animated-text/animated-text-component.js


var AnimatedTextComponent = function(param) {
    var _text = param.text, text = _text === void 0 ? "" : _text;
    var words = text === null || text === void 0 ? void 0 : text.split("");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAnimatedTextComponent, {
        words: words,
        className: "animated-text-component",
        children: words.map(function(word, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "animated-word",
                children: word === " " ? "\xa0" : word
            }, index);
        })
    });
};
/* harmony default export */ var animated_text_component = (AnimatedTextComponent);

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/default-props.js
/* harmony default export */ var default_props = ({});

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/clickable-tags-grid.js

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var ClickableTagsGrid = function(param) {
    var tags = param.tags, tagsTitle = param.tagsTitle, onTagSelectionChange = param.onTagSelectionChange, extraDetails = param.extraDetails;
    var ref = (0,react.useState)([]), selectedTags = ref[0], setSelectedTags = ref[1];
    var handleCardClick = function(tag) {
        var updatedSelectedTags = selectedTags.includes(tag) ? selectedTags.filter(function(selectedTag) {
            return selectedTag !== tag;
        }) : (0,_to_consumable_array/* default */.Z)(selectedTags).concat([
            tag
        ]);
        setSelectedTags(updatedSelectedTags);
        onTagSelectionChange && onTagSelectionChange(updatedSelectedTags);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledClickableTagsGrid, {
        className: "clickable-tags-grid",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(animated_text_component, {
                text: tagsTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tags-container",
                children: tags === null || tags === void 0 ? void 0 : tags.map(function(tag, index) {
                    return /*#__PURE__*/ (0,react.createElement)(tag_component, _object_spread_props(_object_spread({}, tag), {
                        key: index,
                        selected: selectedTags.includes(tag),
                        onClick: function() {
                            return handleCardClick(tag);
                        }
                    }));
                })
            }),
            extraDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "extra-details",
                children: [
                    extraDetails.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "title",
                        children: extraDetails.title
                    }),
                    extraDetails.imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        src: extraDetails.imageSrc
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var clickable_tags_grid = (ClickableTagsGrid);
ClickableTagsGrid.defaultProps = default_props;

// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/tags-and-assets/tags-and-assets-component.js
function tags_and_assets_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function tags_and_assets_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            tags_and_assets_component_define_property(target, key, source[key]);
        });
    }
    return target;
}









var TagsAndAssetsComponent = function(param) {
    var tagsTitle = param.tagsTitle, tags = param.tags, defaultImage = param.defaultImage, onClustersChange = param.onClustersChange, extraDetails = param.extraDetails, enabledDefaultImageAnimation = param.enabledDefaultImageAnimation;
    var ref = (0,react.useState)(null), latestSelectedTab = ref[0], setLatestSelectedTab = ref[1];
    var ref1 = (0,react.useState)(false), didDefaultClicked = ref1[0], setDidDefaultClicked = ref1[1];
    var tagAssets = (0,react.useMemo)(function() {
        return tags === null || tags === void 0 ? void 0 : tags.map(function(param) {
            var tagImage = param.tagImage;
            return tagImage;
        });
    }, [
        tags
    ]);
    var onTagSelectionChange = (0,react.useCallback)(function(selectedTags) {
        setLatestSelectedTab(selectedTags[selectedTags.length - 1] || null);
        onClustersChange(selectedTags);
    }, []);
    var onAssetClick = function() {
        if (latestSelectedTab) return;
        setDidDefaultClicked(true);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.TAGS_DEFAULT_ASSET_CLICKED);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTagsAndAssetsComponent, {
        className: "tags-and-assets-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("use-cases-container", {
                    "with-extra-details": !!extraDetails,
                    breathe: enabledDefaultImageAnimation && didDefaultClicked
                }),
                onAnimationEnd: function() {
                    return setDidDefaultClicked(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(clickable_tags_grid, {
                    onTagSelectionChange: onTagSelectionChange,
                    tags: tags,
                    tagsTitle: tagsTitle,
                    extraDetails: extraDetails
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "assets-container",
                onClick: onAssetClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("default-asset", {
                            active: !latestSelectedTab
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, tags_and_assets_component_object_spread({
                            hideControls: true
                        }, defaultImage))
                    }),
                    tagAssets === null || tagAssets === void 0 ? void 0 : tagAssets.map(function(tagAsset, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("picture-wrapper", {
                                selected: latestSelectedTab === tags[index]
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                src: (tagAsset === null || tagAsset === void 0 ? void 0 : tagAsset.src) || (defaultImage === null || defaultImage === void 0 ? void 0 : defaultImage.src)
                            }, index)
                        });
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var tags_and_assets_component = (TagsAndAssetsComponent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/hr-icon.js

var HrIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1518_54262)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.86963 6.35416C3.86963 7.13427 4.17953 7.88242 4.73115 8.43405C5.28278 8.98569 6.03095 9.29559 6.81106 9.29559C7.59118 9.29559 8.33935 8.98569 8.89096 8.43405C9.4426 7.88242 9.7525 7.13427 9.7525 6.35416C9.7525 5.57404 9.4426 4.82587 8.89096 4.27424C8.33935 3.72262 7.59118 3.41272 6.81106 3.41272C6.03095 3.41272 5.28278 3.72262 4.73115 4.27424C4.17953 4.82587 3.86963 5.57404 3.86963 6.35416Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.99756 15.1715C1.99756 13.895 2.50467 12.6707 3.40733 11.768C4.30999 10.8654 5.53426 10.3583 6.81082 10.3583C8.08737 10.3583 9.31165 10.8654 10.2143 11.768C11.1169 12.6707 11.6241 13.895 11.6241 15.1715",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.6973 7.95424C11.6973 8.59251 11.9508 9.20462 12.4021 9.65599C12.8534 10.1073 13.4655 10.3609 14.1038 10.3609C14.7422 10.3609 15.3543 10.1073 15.8056 9.65599C16.257 9.20462 16.5105 8.59251 16.5105 7.95424C16.5105 7.31596 16.257 6.70382 15.8056 6.25249C15.3543 5.80116 14.7422 5.54761 14.1038 5.54761C13.4655 5.54761 12.8534 5.80116 12.4021 6.25249C11.9508 6.70382 11.6973 7.31596 11.6973 7.95424Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.739 11.4793C13.3345 11.2598 13.9741 11.1874 14.6036 11.2683C15.2331 11.3491 15.8337 11.5807 16.3544 11.9435C16.8751 12.3064 17.3005 12.7896 17.5943 13.3521C17.8881 13.9146 18.0418 14.5398 18.0422 15.1744",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1518_54262",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "17.1138",
                        height: "17.1138",
                        fill: "white",
                        transform: "translate(1.46265 0.731323)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/it-icon.js

var ItIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1518_54236)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.6401 11.9388V5.14156C16.6401 4.86422 16.53 4.59822 16.3338 4.40211C16.1377 4.206 15.8717 4.09583 15.5944 4.09583H5.13704C4.8597 4.09583 4.59371 4.206 4.3976 4.40211C4.20149 4.59822 4.09131 4.86422 4.09131 5.14156V11.9388H16.6401Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18.1184 15.1721C18.1891 15.3314 18.219 15.5057 18.2052 15.6794C18.1914 15.8531 18.1345 16.0206 18.0395 16.1666C17.9446 16.3128 17.8146 16.4328 17.6615 16.5158C17.5083 16.5989 17.3369 16.6424 17.1626 16.6424H3.56809C3.39385 16.6424 3.22238 16.5989 3.06924 16.5158C2.91611 16.4328 2.78615 16.3128 2.69119 16.1666C2.59623 16.0206 2.53927 15.8531 2.52549 15.6794C2.51171 15.5057 2.54155 15.3314 2.61228 15.1721L4.09095 11.9366H16.6397L18.1184 15.1721Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.3208 14.5527H11.4123",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1518_54236",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16.7317",
                        height: "16.7317",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/crm-icon.js

var CrmIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1518_54207)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.8333 12.673V15.173L14.8333 12.673H16.8333C17.0985 12.673 17.3529 12.5677 17.5404 12.3802C17.7279 12.1926 17.8333 11.9382 17.8333 11.673V3.67303C17.8333 3.40782 17.7279 3.15346 17.5404 2.96593C17.3529 2.77839 17.0985 2.67303 16.8333 2.67303H8.83325C8.56804 2.67303 8.31368 2.77839 8.12615 2.96593C7.93861 3.15346 7.83325 3.40782 7.83325 3.67303",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.98389 8.38837C2.80415 9.23838 3.86385 9.81838 5.02193 10.0512C6.18 10.284 7.38152 10.1586 8.46659 9.69171",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.49976 10.168C1.49976 11.0962 1.8685 11.9864 2.52488 12.6428C3.18126 13.2992 4.0715 13.668 4.99976 13.668C5.92802 13.668 6.81825 13.2992 7.47463 12.6428C8.13102 11.9864 8.49976 11.0962 8.49976 10.168C8.49976 9.2397 8.13102 8.34948 7.47463 7.6931C6.81825 7.03672 5.92802 6.66797 4.99976 6.66797C4.0715 6.66797 3.18126 7.03672 2.52488 7.6931C1.8685 8.34948 1.49976 9.2397 1.49976 10.168Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.1164 17.6691C9.12289 16.3927 7.68802 15.534 6.09364 15.2616C4.49926 14.9893 2.86065 15.3229 1.49976 16.1971",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.6667 9.99524H10.3334",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.9998 5.33551H12.8664V10.0022H14.9998V5.33551Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.8674 7.04608H10.7341V10.0016H12.8674V7.04608Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1518_54207",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "16",
                        fill: "white",
                        transform: "translate(1 2)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/product-icon.js

var ProductIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.8139 15.8139C16.8139 16.0567 16.7175 16.2895 16.5458 16.4611C16.3742 16.6327 16.1413 16.7292 15.8986 16.7292H4.91528C4.67253 16.7292 4.43972 16.6327 4.26808 16.4611C4.09643 16.2895 4 16.0567 4 15.8139V3.91528C4 3.67253 4.09643 3.43972 4.26808 3.26808C4.43972 3.09643 4.67253 3 4.91528 3H14.0955C14.3345 3.00003 14.564 3.09354 14.735 3.26055L16.5381 5.0191C16.6255 5.10442 16.6948 5.20635 16.7422 5.3189C16.7896 5.43144 16.814 5.55233 16.8139 5.67444V15.8139Z",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.8066 8.04395L14.0948 10.3321L11.8066 12.6203",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.06163 8.04395L6.77344 10.3321L9.06163 12.6203",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/operations-icon.js

var OperationsIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.4163 10.0533C13.4033 10.8686 13.0704 11.6461 12.4893 12.218C11.9082 12.7899 11.1255 13.1105 10.3102 13.1105C9.49483 13.1105 8.71221 12.7899 8.13111 12.218C7.55001 11.6461 7.21706 10.8686 7.2041 10.0533",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.6875 10.0393V11.207L16.3525 11.474C16.1985 12.1212 15.9404 12.7391 15.5885 13.3036L16.3494 14.4376L14.7003 16.0866L13.5672 15.3257C13.0025 15.6807 12.3833 15.9405 11.7344 16.0945L11.4706 17.4224H9.14618L8.88154 16.0945C8.23284 15.9403 7.61391 15.6806 7.0495 15.3257L5.91322 16.0835L4.26417 14.4344L5.02509 13.3005C4.67286 12.736 4.41455 12.1181 4.26024 11.4708L2.92529 11.2039V10.0393",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.4163 9.57697C13.4033 8.7617 13.0704 7.98421 12.4893 7.41231C11.9082 6.8404 11.1255 6.51986 10.3102 6.51986C9.49483 6.51986 8.71221 6.8404 8.13111 7.41231C7.55001 7.98421 7.21706 8.7617 7.2041 9.57697",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.6875 9.57697V8.40928L16.3525 8.14229C16.1985 7.49507 15.9404 6.87715 15.5885 6.31262L16.3494 5.1787L14.7003 3.52965L13.5672 4.29057C13.0025 3.93555 12.3833 3.67579 11.7344 3.5218L11.4706 2.19392H9.14618L8.88154 3.5218C8.23284 3.67594 7.61391 3.93563 7.0495 4.29057L5.91322 3.53279L4.26417 5.18184L5.02509 6.31577C4.67286 6.88029 4.41455 7.49821 4.26024 8.14543L2.92529 8.41242V9.57697",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/marketing-icon.js

var MarketingIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.87023 11.7385H4.17756C3.42936 11.7385 2.71179 11.4412 2.18273 10.9122C1.65367 10.3831 1.35645 9.6656 1.35645 8.91737C1.35645 8.16913 1.65367 7.4516 2.18273 6.92254C2.71179 6.39348 3.42936 6.09625 4.17756 6.09625H5.87023V11.7385Z",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.87012 11.735C9.18105 11.7353 12.418 12.7153 15.173 14.5516L16.0261 15.1204V2.70746L15.173 3.2762C12.418 5.11251 9.18105 6.09252 5.87012 6.0928V11.735Z",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.2825 7.78906V10.046",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.87012 11.7385C5.86964 12.4772 6.01945 13.2083 6.31045 13.8873C6.60144 14.5663 7.02753 15.179 7.56279 15.6881",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/design-icon.js

var DesignIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.9521 16.8926H3.92617C3.68054 16.8926 3.44496 16.795 3.27127 16.6214C3.09758 16.4477 3 16.212 3 15.9664V3.92617C3 3.68054 3.09758 3.44496 3.27127 3.27127C3.44496 3.09758 3.68054 3 3.92617 3H15.9664C16.212 3 16.4477 3.09758 16.6214 3.27127C16.795 3.44496 16.8926 3.68054 16.8926 3.92617V10.9521C16.8925 11.1976 16.795 11.433 16.6215 11.6066L11.6066 16.6215C11.433 16.795 11.1976 16.8925 10.9521 16.8926Z",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.3362 16.8124V12.2649C11.3362 12.0193 11.4337 11.7837 11.6074 11.61C11.7811 11.4363 12.0167 11.3387 12.2624 11.3387H16.8099",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.70483 6.70087H14.1142",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.70483 9.48566H9.94644",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/tasks-icon.js

var TasksIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.87871 2.92523H16.2731C16.2731 2.92523 17.2265 2.92523 17.2265 3.87865V16.273C17.2265 16.273 17.2265 17.2264 16.2731 17.2264H3.87871C3.87871 17.2264 2.92529 17.2264 2.92529 16.273V3.87865C2.92529 3.87865 2.92529 2.92523 3.87871 2.92523Z",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.24429 6.10449L6.41373 8.54523L5.19336 7.32487",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5059 7.68658H14.3661",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.24429 11.5956L6.41373 14.0364L5.19336 12.816",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5059 13.4136H14.3661",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/projects-icon.js

var ProjectsIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.88281 1.87549H13.1328C13.1328 1.87549 14.3828 1.87549 14.3828 3.12549V11.8755C14.3828 11.8755 14.3828 13.1255 13.1328 13.1255H1.88281C1.88281 13.1255 0.632812 13.1255 0.632812 11.8755V3.12549C0.632812 3.12549 0.632812 1.87549 1.88281 1.87549Z",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.632812 5.61993H14.3828",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.8823 5.61993V14.3699C16.8823 14.7015 16.7507 15.0194 16.5162 15.2538C16.2818 15.4882 15.9638 15.6199 15.6323 15.6199H4.38232",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.3826 8.11621V16.8662C19.3826 17.1978 19.2509 17.5157 19.0165 17.7501C18.7821 17.9845 18.4641 18.1162 18.1326 18.1162H6.88257",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/index.js










// EXTERNAL MODULE: ./constants/clusters.js
var constants_clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/consts.js




var _obj;
var CLUSTER_TO_PRODUCT_MAP = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, constants_clusters.SOFTWARE, products/* DEV_PRODUCT_ID */.xi), (0,src_define_property/* default */.Z)(_obj, constants_clusters.IT, products/* SERVICE_PRODUCT_ID */.Ai), (0,src_define_property/* default */.Z)(_obj, constants_clusters.CRM, products/* CRM_PRODUCT_ID */.$), _obj);
var _obj1;
var CLUSTER_TO_TAG_ICON_MAP = (_obj1 = {}, (0,src_define_property/* default */.Z)(_obj1, constants_clusters.SOFTWARE, ProductIcon), (0,src_define_property/* default */.Z)(_obj1, constants_clusters.TASK_MANAGEMENT, TasksIcon), (0,src_define_property/* default */.Z)(_obj1, constants_clusters.CRM, CrmIcon), (0,src_define_property/* default */.Z)(_obj1, constants_clusters.HR, HrIcon), (0,src_define_property/* default */.Z)(_obj1, constants_clusters.MARKETING, MarketingIcon), (0,src_define_property/* default */.Z)(_obj1, constants_clusters.DESIGN_AND_CREATIVE, DesignIcon), (0,src_define_property/* default */.Z)(_obj1, constants_clusters.IT, ItIcon), (0,src_define_property/* default */.Z)(_obj1, constants_clusters.OPERATIONS, OperationsIcon), (0,src_define_property/* default */.Z)(_obj1, constants_clusters.PRODUCT_MANAGEMENT, ProjectsIcon), _obj1);
var getClusterProduct = function(cluster) {
    return CLUSTER_TO_PRODUCT_MAP[cluster] || null;
};

// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
// EXTERNAL MODULE: ./client/services/hotjar-service/hotjar-service.js
var hotjar_service = __webpack_require__(96339);
// EXTERNAL MODULE: ./services/clusters-service.js + 1 modules
var clusters_service = __webpack_require__(25866);
// EXTERNAL MODULE: ./styles/colors-utils.js
var colors_utils = __webpack_require__(61012);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
;// CONCATENATED MODULE: ./segments/desktop/core-components/clusters-signup/clusters-signup.scss.js




var StyledClustersSignup = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1lbjbkk0"
})("&.cluster-selected{animation:breatheOut 0.3s linear;}.signup-button-wrapper{transform:scale(1);button.signup-button{background-image:", function(param) {
    var background = param.background;
    return background;
}, ";color:", function(param) {
    var textColor = param.textColor;
    return textColor;
}, ";&:disabled{background-image:", function(param) {
    var background = param.background;
    return background;
}, ";color:", function(param) {
    var textColor = param.textColor;
    return textColor;
}, ";}}.sign-up-combo-with-text-underline{.sign-up-combo-wrapper{.signup-combo-buttons-button{justify-content:center;.secondary-button-wrapper{.secondary-button{.with-underline{background:unset;.secondary-button-text{padding-left:8px;}}}&:hover{.secondary-button{.with-underline{.secondary-button-text{transition:color 0.15 ease-in-out;color:", (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], 0.8), ";}svg path{transition:fill 0.15 ease-in-out;fill:", (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], 0.8), ";}}}}}}}.text-wrapper{margin-top:32px;font-size:0.8125rem;text-align:center;padding-left:3px;}}}@keyframes breatheOut{0%{transform:scale(1);}15%{transform:scale(1.01);}20%{transform:scale(1.02);}25%{transform:scale(1.03);}32%{transform:scale(1.04);}50%{transform:scale(1.05);}68%{transform:scale(1.04);}75%{transform:scale(1.03);}80%{transform:scale(1.02);}85%{transform:scale(1.01);}100%{transform:scale(1);}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.js + 2 modules
var product_sign_up = __webpack_require__(61740);
;// CONCATENATED MODULE: ./segments/desktop/core-components/clusters-signup/clusters-signup.js
function clusters_signup_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function clusters_signup_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            clusters_signup_define_property(target, key, source[key]);
        });
    }
    return target;
}
function clusters_signup_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function clusters_signup_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        clusters_signup_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}














var LIGHT_THEME_BUTTON_OPACITY = "ee";
var ClustersSignup = function(_param) {
    var _clusters = _param.clusters, clusters = _clusters === void 0 ? [] : _clusters, wasClusterSelected = _param.wasClusterSelected, selectedProducts = _param.selectedProducts, buttonColor = _param.buttonColor, removeGradient = _param.removeGradient, restOfConfig = _object_without_properties(_param, [
        "clusters",
        "wasClusterSelected",
        "selectedProducts",
        "buttonColor",
        "removeGradient"
    ]);
    var ref = (0,react.useState)(false), isHover = ref[0], setIsHover = ref[1];
    var productType = (0,react.useMemo)(function() {
        return (selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.length) === 1 ? selectedProducts[0] : null;
    }, [
        selectedProducts
    ]);
    var getButtonTextColor = function() {
        if (removeGradient) {
            return buttonColor === color_consts.WHITE_COLOR_NAME ? colors/* default */.Z[color_consts.BRAND_BLACK_BACKGROUND_COLOR] : colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
        }
        if (buttonColor === color_consts.WHITE_COLOR_NAME && clusters.length === 0) {
            return colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME];
        }
        return colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
    };
    var getButtonColorBySelectedClusters = function() {
        if (removeGradient) return colors/* default */.Z[buttonColor];
        if ((clusters === null || clusters === void 0 ? void 0 : clusters.length) === 0) {
            return isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[buttonColor]) : colors/* default */.Z[buttonColor];
        }
        // if only 1 cluster was selected, fill the button with a gradient built of the same color
        if (clusters.length === 1) {
            var colorName = clusters[0].tagBackgroundColor;
            var color = isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[colorName]) : colors/* default */.Z[colorName];
            return "linear-gradient(90deg, ".concat(color).concat(LIGHT_THEME_BUTTON_OPACITY, " 0%, ").concat(color).concat(LIGHT_THEME_BUTTON_OPACITY, " 100%)");
        }
        var colorsString = "";
        var chunkSize = 100 / (clusters.length - 1);
        // building the linear gradient string
        // for example, if 3 clusters are selected, the linear gradient stop locations should be 0%, 50% and 100%
        clusters === null || clusters === void 0 ? void 0 : clusters.forEach(function(param, index) {
            var tagBackgroundColor = param.tagBackgroundColor;
            // add separator in every chunk instead of last chunk
            var separator = index === clusters.length - 1 ? "" : ", ";
            var color = isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[tagBackgroundColor]) : colors/* default */.Z[tagBackgroundColor];
            colorsString += "".concat(color).concat(LIGHT_THEME_BUTTON_OPACITY, " ").concat(chunkSize * index, "%").concat(separator);
        });
        return "linear-gradient(90deg, ".concat(colorsString, ")");
    };
    var saveClustersOnSignup = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SIGNUP_WITH_TAGS, {
            info1: clusters.map(function(tag) {
                return tag.tagText;
            })
        });
        var clustersToUpdate = clusters === null || clusters === void 0 ? void 0 : clusters.map(function(tag) {
            var clusterId = tag.overridePageCluster;
            var useCaseId = tag.overridePageSubCluster;
            var res = [];
            clusterId && res.push({
                clusterId: clusterId,
                clusterType: types.CLUSTER_TYPE
            });
            if (useCaseId) {
                var extraData = clusterId ? {
                    parent_cluster_id: clusterId
                } : {};
                res.push({
                    clusterId: useCaseId,
                    clusterType: types.USE_CASE_TYPE,
                    extraData: extraData
                });
            }
            return res;
        });
        var flattenedArray = clustersToUpdate.flat();
        if (flattenedArray.length > 0) {
            // fire each cluster id as an event, so filtering can be fully customized on Hotjar side
            (0,hotjar_service/* fireHotjarEvents */.no)(flattenedArray.map(function(cluster) {
                return "tag_selected_".concat(cluster.clusterType, "_").concat(cluster.clusterId);
            }));
            (0,clusters_service/* updateUserClustersListWithMultipleClusters */.aC)(flattenedArray, constants_clusters.HP_TAGS_SELECTION);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledClustersSignup, {
        background: getButtonColorBySelectedClusters(),
        textColor: getButtonTextColor(),
        className: classnames_default()("clusters-signup", {
            "cluster-selected": wasClusterSelected
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onMouseEnter: function() {
                return setIsHover(true);
            },
            onMouseLeave: function() {
                return setIsHover(false);
            },
            className: "cta-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_sign_up/* default */.Z, clusters_signup_object_spread_props(clusters_signup_object_spread({}, restOfConfig), {
                buttonSize: "",
                buttonColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
                productType: productType,
                skipUpdateCluster: false,
                beforeSubmitCallback: saveClustersOnSignup
            }))
        })
    });
};
/* harmony default export */ var clusters_signup = (ClustersSignup);

// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/utils.js


var TITLE = "Recommended product";
var utils_obj;
var PRODUCT_TO_IMAGE = (utils_obj = {}, (0,src_define_property/* default */.Z)(utils_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, "https://dapulse-res.cloudinary.com/image/upload/v1721314020/Generator_featured%20images/Homepage%20-%202024/Products-%20logos/Logo-wm.png"), (0,src_define_property/* default */.Z)(utils_obj, products/* CRM_PRODUCT_ID */.$, "https://dapulse-res.cloudinary.com/image/upload/v1721314020/Generator_featured%20images/Homepage%20-%202024/Products-%20logos/Logo-crm.png"), (0,src_define_property/* default */.Z)(utils_obj, products/* DEV_PRODUCT_ID */.xi, "https://dapulse-res.cloudinary.com/image/upload/v1721314020/Generator_featured%20images/Homepage%20-%202024/Products-%20logos/Logo-dev.png"), (0,src_define_property/* default */.Z)(utils_obj, products/* SERVICE_PRODUCT_ID */.Ai, "https://dapulse-res.cloudinary.com/image/upload/v1721314019/Generator_featured%20images/Homepage%20-%202024/Products-%20logos/Logo-dervice.png"), utils_obj);
var getSelectedProductDetails = function() {
    var selectedProducts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (!selectedProducts.length) return null;
    var selectedProduct = selectedProducts[selectedProducts.length - 1] || products/* WORK_MANAGEMENT_PRODUCT_ID */.py;
    return {
        title: TITLE,
        imageSrc: PRODUCT_TO_IMAGE[selectedProduct]
    };
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/side-by-side-paragraph-and-tags-homepage-first-fold-component.js
function side_by_side_paragraph_and_tags_homepage_first_fold_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_paragraph_and_tags_homepage_first_fold_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_paragraph_and_tags_homepage_first_fold_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_paragraph_and_tags_homepage_first_fold_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_paragraph_and_tags_homepage_first_fold_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_paragraph_and_tags_homepage_first_fold_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_paragraph_and_tags_homepage_first_fold_component_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_paragraph_and_tags_homepage_first_fold_component_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_paragraph_and_tags_homepage_first_fold_component_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









var SIGNUP_BUTTON_ANIMATION_START_TIME = 100;
var SideBySideParagraphAndTagsHomepageFirstFoldComponent = function(param) {
    var fullParagraph = param.fullParagraph, gap = param.gap, tagsTitle = param.tagsTitle, tags = param.tags, fullParagraphAdvancedConfig = param.fullParagraphAdvancedConfig, defaultImage = param.defaultImage, minHeight = param.minHeight, fullParagraphTopMargin = param.fullParagraphTopMargin, showSelectedProduct = param.showSelectedProduct, enabledDefaultImageAnimation = param.enabledDefaultImageAnimation;
    var ref = (0,react.useState)([]), selectedClusters = ref[0], setSelectedClusters = ref[1];
    var ref1 = (0,react.useState)(false), wasClusterSelected = ref1[0], setWasClusterSelected = ref1[1];
    var assetTags = (0,react.useMemo)(function() {
        return tags === null || tags === void 0 ? void 0 : tags.map(function(_param) {
            var tagText = _param.tagText, tagColor = _param.tagColor, tag = side_by_side_paragraph_and_tags_homepage_first_fold_component_object_without_properties(_param, [
                "tagText",
                "tagColor"
            ]);
            return side_by_side_paragraph_and_tags_homepage_first_fold_component_object_spread_props(side_by_side_paragraph_and_tags_homepage_first_fold_component_object_spread({}, tag), {
                text: tagText,
                tagColor: tagColor,
                Icon: CLUSTER_TO_TAG_ICON_MAP[tag === null || tag === void 0 ? void 0 : tag.overridePageCluster] || CLUSTER_TO_TAG_ICON_MAP[tag === null || tag === void 0 ? void 0 : tag.overridePageSubCluster]
            });
        });
    }, [
        tags
    ]);
    var selectedProducts = (0,react.useMemo)(function() {
        return selectedClusters.map(function(param) {
            var overridePageCluster = param.overridePageCluster;
            return getClusterProduct(overridePageCluster);
        });
    }, [
        selectedClusters
    ]);
    var selectedProductDetails = (0,react.useMemo)(function() {
        return showSelectedProduct && getSelectedProductDetails(selectedProducts);
    }, [
        selectedProducts,
        showSelectedProduct
    ]);
    var onClustersChange = function(selectedTags) {
        setSelectedClusters(selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.map(function(param) {
            var tagColor = param.tagColor, overridePageCluster = param.overridePageCluster, overridePageSubCluster = param.overridePageSubCluster;
            return {
                tagBackgroundColor: tagColor,
                overridePageSubCluster: overridePageSubCluster,
                overridePageCluster: overridePageCluster
            };
        }));
        selectedTags && setTimeout(function() {
            return setWasClusterSelected(true);
        }, SIGNUP_BUTTON_ANIMATION_START_TIME);
    };
    var renderClusterButton = function() {
        var _fullParagraph_buttonConfig;
        return (fullParagraph === null || fullParagraph === void 0 ? void 0 : (_fullParagraph_buttonConfig = fullParagraph.buttonConfig) === null || _fullParagraph_buttonConfig === void 0 ? void 0 : _fullParagraph_buttonConfig.buttonType) === button_consts/* SIGNUP_BUTTON_TYPE */.ge ? /*#__PURE__*/ (0,jsx_runtime.jsx)(clusters_signup, side_by_side_paragraph_and_tags_homepage_first_fold_component_object_spread_props(side_by_side_paragraph_and_tags_homepage_first_fold_component_object_spread({}, fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.buttonConfig), {
            wasClusterSelected: wasClusterSelected,
            clusters: selectedClusters,
            selectedProducts: selectedProducts
        })) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSideBySideParagraphAndTagsHomepageFirstFoldComponent, {
        gap: gap,
        minHeight: minHeight,
        fullParagraphTopMargin: fullParagraphTopMargin,
        className: "side-by-side-paragraph-and-tags-homepage-first-fold-component",
        onAnimationEnd: function() {
            return setWasClusterSelected(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, side_by_side_paragraph_and_tags_homepage_first_fold_component_object_spread({
                renderButton: renderClusterButton
            }, fullParagraph, fullParagraphAdvancedConfig)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tags_and_assets_component, {
                onClustersChange: onClustersChange,
                tagsTitle: tagsTitle,
                tags: assetTags,
                defaultImage: defaultImage,
                extraDetails: selectedProductDetails,
                enabledDefaultImageAnimation: enabledDefaultImageAnimation
            })
        ]
    });
};
/* harmony default export */ var side_by_side_paragraph_and_tags_homepage_first_fold_component = (SideBySideParagraphAndTagsHomepageFirstFoldComponent);


/***/ })

}]);